import React, { useEffect, useState } from 'react'
import { Modal } from "antd";
import styled from "@emotion/styled";
import COLORS from 'common/Colors';
import GridBuilder from 'UIBuilderEngine/GridBuilder';
import { InitalSteps } from 'common/Constants';

const StyledModal = styled(Modal)`
  border-radius: 10px;
  padding-top: 5%;
  p{
    font-size: 18px;
    color: ${COLORS.TEXT.PRIMARY};
    font-weight: 600;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-modal-footer {
    display: none;
  }
  .stylebtn{
    min-width: 150px;
  }
`;

function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}


function AddHiringProcess({ isModalOpen, handleCancel, handleOk, loading, name, handleSubmit, initialValue, isEdit = false }) {

    console.log("initialValue--->", initialValue)
    const [newStep, setNewStep] = useState(InitalSteps)
    const [reset, setReset] = useState();
    const [infoHovered, setInfoHovered] = useState(false);
    const Form = {
        totalpages: 1,
        pages: [
            {
                modalView: false, 
                colSpan: [12, 12, 12, 12], 
                stagesButton: true,
                fields: [
                    // Row 1
                    [
                        {
                            id: 1,
                            label: "Name of the Hiring Process",
                            type: "text",
                            name: "title",
                            Placeholder: "Process Name",
                            value: '',
                            validationRules: [
                                {
                                    required: true,
                                    message: `Please Enter Process Name`,
                                },

                            ],
                            maxLength: 50
                        },
                    ],
                    [
                        {
                            id: 2,
                            label: "Steps Involved in Hiring",
                            type: "addlist",
                            name: "steps",
                            Placeholder: "Add Step Name",
                            value: "",
                            validationRules: [
                                {
                                    required: true,
                                    message: `This field is required`,
                                },

                            ],
                            onKeyDown: /^[a-zA-Z\s]+$/,
                            maxLength: 30
                        },
                    ],
                    [
                        {
                            id: 3,
                            label: "Show email popup only for the first candidate movement; automate for the rest",
                            type: "checkbox",
                            name: "checkbox",
                        }
                    ],
                    [
                        {
                            id: 7,
                            label: "Cancel",
                            type: "button",
                            // position: "center", // position options (end, start, center) 
                            stagesButtonStyle: true,
                            event: "click",
                        },
                        {
                            id: 8,
                            label: isEdit ? "Save Changes" : "Add",
                            type: "button",
                            // position: "center", // position options (end, start, center)
                            stagesButtonStyle: true,
                            event: "submit",
                        },
                    ],
                    
                ],
            },
        ],
    };

    const [initialState, setInitialState] = useState({})
    // const formatSteps = (stepsArray) => {
    //     const defaultSteps = ["Interview", "Not Selected", "Selected"];
    //     const result = [];

    //     // Combine "New" and default steps into one string
    //     const combinedStep = `New, ${defaultSteps.join(", ")}`;
    //     result.push({ "0": combinedStep });

    //     // Get all custom steps excluding "New" and default steps
    //     const customSteps = stepsArray
    //         ?.map(obj => Object.values(obj)[0])
    //         ?.filter(step => step !== "New" && !defaultSteps.includes(step));

    //     // Add custom steps starting from index 1
    //     customSteps?.forEach((step, index) => {
    //         result.push({ [index + 1]: step });
    //     });

    //     return result;
    // };
    const formatSteps = (stepsArray) => {
    const defaultSteps = ["Interview", "Not Selected", "Selected"];
    const result = [];

    const combinedStep = `New, ${defaultSteps.join(", ")}`;
    const addedSteps = new Set(["New", ...defaultSteps]);

    // Always insert combinedStep at index 0
    result.push({ "0": combinedStep });

    // Get raw step values from input
    const customSteps = stepsArray
        ?.map(obj => Object.values(obj)[0])
        ?.filter(step => step !== combinedStep && !addedSteps.has(step)) || [];

    // Add unique custom steps
    let index = 1;
    for (const step of customSteps) {
        if (!addedSteps.has(step)) {
            result.push({ [index++]: step });
            addedSteps.add(step);
        }
    }

    return result;
};



    // const formatSteps = (stepsArray) => {
    //     const defaultSteps = ["Interview", "Not Selected", "Selected"];
    //     const result = [];

    //     const flatSteps = [];

    //     stepsArray.forEach(obj => {
    //         const value = Object.values(obj)[0]; // get the string value from the object
    //         if (typeof value === "string") {
    //         const parts = value.split(",").map(s => s.trim());
    //         flatSteps.push(...parts);
    //         }
    //     });

    //     // Remove duplicates
    //     const uniqueSteps = [...new Set(flatSteps)];

    //     // Separate default and custom steps
    //     const customSteps = uniqueSteps.filter(
    //         step => step !== "New" && !defaultSteps.includes(step)
    //     );
    //     const hasNew = uniqueSteps.includes("New");

    //     let index = 0;

    //     if (hasNew) {
    //         result.push({ [index++]: "New" });
    //     }

    //     customSteps.forEach(step => {
    //         result.push({ [index++]: step });
    //     });

    //     defaultSteps.forEach(step => {
    //         result.push({ [index++]: step });
    //     });

    //     return result;
    // };


    console.log("isEdit--->", isEdit)
    // useEffect(() => {
    //     console.log("initialValue12121--->", initialValue.steps)
    //     const formattedSteps = formatSteps(initialValue.steps);
    //     console.log("formattedSteps121121-->", formattedSteps)
    //     const obj = {
    //         ...initialValue,
    //         steps: formattedSteps
    //     }
    //     console.log("obj-->", obj)
    //     setInitialState(obj)
    // }, [initialValue, isModalOpen])
    useEffect(() => {
    if (!initialValue?.steps?.some(step => Object.values(step)[0] === "New, Interview, Not Selected, Selected")) {
        const formattedSteps = formatSteps(initialValue.steps);
        setInitialState({
            ...initialValue,
            steps: formattedSteps
        });
    } else {
        setInitialState(initialValue); // Already formatted
    }
}, [initialValue, isModalOpen]);


    useEffect(() => {
        setNewStep(InitalSteps)
        setReset(getRandomNumber(1,100))
    }, [isModalOpen])
    console.log("newStep--->", newStep)
    console.log("initialState--->", initialState)
    return (
        <div>
            <StyledModal
                title=""
                visible={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                closeIcon={false}

            >
                <div className='mt-3'>
                    <h5>Adding Hiring process</h5>
                    {isEdit && (
                        <GridBuilder
                            formStructureJson={Form}
                            formSubmit={handleSubmit}
                            loading={loading}
                            handleBack={handleCancel}
                            initialValues={initialState}
                            infoHovered={infoHovered}
                            setInfoHovered={setInfoHovered}
                        />
                    )}
                    {!isEdit && (
                        <GridBuilder
                            formStructureJson={Form}  
                            formSubmit={handleSubmit}
                            loading={loading}
                            handleBack={handleCancel}
                            initialValues={newStep}
                            isModalOpen={reset}
                            infoHovered={infoHovered}
                            setInfoHovered={setInfoHovered}
                        />
                    )}


                </div>
            </StyledModal>
            <Modal
                open={infoHovered}
                onCancel={() => setInfoHovered(false)}
                footer={false}
            >
                <div>
                    <p className='statges_header'>Default Stages</p>
                    <p className='stages_content'><span className='stages_title'>New:</span> View newly applied applicants.</p>
                    <p className='stages_content'><span className='stages_title'>Disqualified:</span> Find candidates who did not meet the criteria.</p>
                    <p className='stages_content'><span className='stages_title'>Selected:</span> See the candidates who have successfully passed their hiring process. 
                        These candidates have been chosen for the position and are issued an offer letter.
                        As part of the offer acceptance process, they will provide additional personal and professional 
                        information through the form we provide. Once the offer is accepted and the necessary
                        information is collected, these candidates can be directly onboarded, including issuing them a 
                        contract through the system if required.
                    </p>
                </div>
            </Modal>
        </div>
    )
}

export default AddHiringProcess